import { RelationSizeParams } from '../'
import { branch } from '../constants'

module.exports = (transaction) ->
  { className } = RelationSizeParams
  configNode = new Weaver.Node(className)
  configNode.set('name', className)
  await configNode.save({ transaction, branch, commitMessage: "Add Relation Size Params Migration." })
  relationSizeParams = new RelationSizeParams()
  await relationSizeParams.reset({ transaction })
